// extracted by mini-css-extract-plugin
export default {"label":"ci_label__tZiGH","c":"ci_c__H1OdP"};